module.exports = {
	"core": {
		"dbcache": 4000,
		"maxorphantx": 1000,
		"maxmempool": 1000,
		"blockreconstructionextratxn": 1000
	},
	"debug": {
		"maxsigcachesize": 100
	},
	"mining": {
		"blockmaxweight": 4000000
	},
	"network": {
		"peerbloomfilters": 0
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Presets/mining.json
 ** module id = 42
 ** module chunks = 0
 **/